// extracted by mini-css-extract-plugin
module.exports = {"profileCard":"style_profileCard__HGOti","variableColumn":"style_variableColumn__aCdlW","editWrapper":"style_editWrapper__70QqH"};